"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentId = void 0;
var getComponentId = function () {
    var query = new URLSearchParams(window.location.search);
    return query.get('origCompId');
};
exports.getComponentId = getComponentId;
//# sourceMappingURL=query.js.map